import { PropsWithChildren, ReactNode } from 'react';

import { motion } from 'motion/react';

import { useToggle } from '@hooks';
import { Above, ActionButton, Only, Text } from '@ui';

import * as css from './PillGroup.css';

type PillProps = {
    isSelected: boolean;
    isDisabled?: boolean;
    border?: boolean;
    onClick: () => void;
    label: string;
    left?: ReactNode;
    right?: ReactNode;
};

export const Pill = ({ isSelected, onClick, label, border, left, right, isDisabled }: PillProps) => (
    <div
        className={css.pill({ active: isSelected, border, disabled: isDisabled })}
        onClick={!isDisabled ? onClick : undefined}
    >
        {left}
        <Text variant="small">
            <b>{label}</b>
        </Text>
        {right}
    </div>
);

type PillGroupProps = { search: ReactNode };

export const PillGroup = ({ children, search }: PropsWithChildren<PillGroupProps>) => {
    const [isOpen, toggleIsOpen] = useToggle();
    return (
        <>
            <Only bp="sm">
                <div className={css.filters}>
                    <div className={css.search}>
                        {search}
                        <ActionButton
                            icon={isOpen ? 'caret-up' : 'caret-down'}
                            variant="plain"
                            onClick={toggleIsOpen}
                        />
                    </div>
                    {isOpen && (
                        <motion.div
                            className={css.pillGroup}
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.25 }}
                        >
                            {children}
                        </motion.div>
                    )}
                </div>
            </Only>
            <Above bp="md">
                <div className={css.filters}>
                    {search}
                    <div className={css.pillGroup}>{children}</div>
                </div>
            </Above>
        </>
    );
};
